module.exports = "2839dc66eb8ee1ff6c7788b5ab6bdff3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-top-r-3.png
// module id = 64
// module chunks = 0